export const environment = {
  BASE_URL: 'https://test.oblation.satsangnepal.org.np',
  SSO_URL: 'https://sso2.test.satsang.org.in/',
  localhostUrl: '',
  orgUrl: 'https://satsangnepal.org.np/',
  returnUrl: 'https://test.oblation.satsangnepal.org.np/pre-login',
  photoSocketUrl: 'wss://test.oblation.satsangnepal.org.np/socket',
  activityLogoutTimeInMins: 60,
  production: false,
  IST_FORM: ['APRNM', 'DPRNM'],
  MISC_CODE_TYPE: ['MANDIR', 'MISC'],
  PHIL_NAME: 'Satsang Philanthropy Nepal',
  BASE_COUNTRY: 'Nepal',
  STATE_LABEL: 'PROVINCE',
  DISTRICT_LABEL: 'DISTRICT',
  LOCAL_ADMIN_DIV: 'MUNICIPALITY',
  ISD_CODE: '+977',
  CONTACT_NO_LENGTH: 10,
  CONTACT_NO_REGEX: '^(97|98)\\d{8}$',
};
